import Header from "@/components/Header/components";
import FormsMixin from "@/mixins/FormsMixin";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { ARTICULO, ARTICULO_WEB, CESTA } from "@/store/modules/ventas/types";
import { Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import Template from "./template.vue";

@Component({
  mixins: [Template],
  components: { Header }
})
export default class Historico extends FormsMixin {
  @Action("listarArticulos", { namespace: "Historico" }) listarArticulos!: Function;
  @Action("listarArticulosFiltrado", { namespace: "ventas" }) listarArticulosFiltrado!: Function;
  @Action("postActualizaFavorito", { namespace: "ventas" }) postActualizaFavorito!: Function;
  @Action("GetImageUrl", { namespace: "general" }) GetImageUrl!: Function;
  @State('isMobile') isMobile!: boolean;
  @Action("GetConfig", { namespace: "ventas" }) getConfig!: Function;

  public listadoArticulos: Array<ARTICULO> = [];
  public cesta: Array<CESTA> = [];
  public Favoritos = false;
  public imageUrl = "";
  public listadoWeb: ARTICULO_WEB = {
    total: 0,
    lstArticulo: []

  }
  public cliente: CLIENTES = {
      CODCLI: "",
      NOMCLI: "",
      AT_APP: "",
      AT_PASSWORD: "",
      CODREP: "",
      E_MAIL: "",
      NIFCLI: ""
    };
  search = "";

  public currentPage = 1;
  public itemsPerPage = 10;
  public perPageValues = [5, 10, 15, 20];
  public total = 0;
  public stockConfig = true;

  async mounted() {
      const esCliente = JSON.parse(localStorage.getItem('userLogged') || '{}').esCliente;
      this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');

      const res = await this.getConfig();
      res == 'T' ? this.stockConfig = true : this.stockConfig = false;

      this.$root.$emit("loading", true);
      if (esCliente) {
        this.listadoWeb = await this.listarArticulos({ codcli: this.cliente.CODCLI, codrep: "" , page: this.currentPage, items: this.itemsPerPage});
      } else {
        const idRep = JSON.parse(localStorage.getItem('userLogged') || '{}').id;
        this.listadoWeb = await this.listarArticulos({ codcli: this.cliente.CODCLI, codrep: idRep, page: this.currentPage, items: this.itemsPerPage });
      }

      this.listadoArticulos = this.listadoWeb?.lstArticulo;
      this.total = this.listadoWeb.total;

      if(this.listadoArticulos == undefined) this.listadoArticulos = [];

      if(this.listadoArticulos != null && this.listadoArticulos != undefined){
        this.listadoArticulos.forEach(art =>{
          art.CANTIDAD = this.getCantidadCesta(art.CODART);
        })
      }

      this.imageUrl = await this.GetImageUrl();

      this.$root.$emit("loading", false);
      this.$root.$on("devolverCesta", (cesta: Array<CESTA>) => { this.cesta = cesta })
      this.$root.$emit("solicitarCesta");
      
    window.scrollTo(0, 0);
  }

  get listadoArticulosFiltrados() {
    if (this.search == "") return this.listadoArticulos;
    return this.listadoArticulos.filter(x=>x.DESCART.toUpperCase().includes(this.search.toUpperCase()) || x.CODART.toUpperCase().includes(this.search.toUpperCase()));
  }

  async paginar(){
    const esCliente = JSON.parse(localStorage.getItem('userLogged') || '{}').esCliente;
      this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');
    this.$root.$emit("loading", true);
    if (esCliente) {
      this.listadoWeb = await this.listarArticulos({ codcli: this.cliente.CODCLI, codrep: "" , page: this.currentPage, items: this.itemsPerPage});
    } else {
      const idRep = JSON.parse(localStorage.getItem('userLogged') || '{}').id;
      this.listadoWeb = await this.listarArticulos({ codcli: this.cliente.CODCLI, codrep: idRep, page: this.currentPage, items: this.itemsPerPage });
    }

    this.listadoArticulos = this.listadoWeb?.lstArticulo;
    this.total = this.listadoWeb.total;

    if(this.listadoArticulos == undefined) this.listadoArticulos = [];

    if(this.listadoArticulos != null && this.listadoArticulos != undefined){
      this.listadoArticulos.forEach(art =>{
        art.CANTIDAD = this.getCantidadCesta(art.CODART);
      })
    }

      this.$root.$emit("loading", false);
  }

  clearSearch() {
    this.search ="";
    this.$forceUpdate();
  }

  getCantidadCesta(codart: string) {      
    const existe = this.cesta.find(x => x.articulo.CODART == codart);
    if (existe != undefined) {
      return existe.cantidad
    } else { return 0; }
  }

  AñadirACesta(item: ARTICULO) {
    this.$root.$emit("addToCart", item)
  }

  RestarDeCesta(item: ARTICULO){
    this.$root.$emit("RestCart", item)
  }

  Volver(){
    this.$router.push({ name: "venta"});
  }

  async ActualizaFavorito(item: ARTICULO){
    
    console.log(item);
    await this.postActualizaFavorito({
      favorito: !item.FAVORITO,
      codcli: this.cliente.CODCLI,
      codart: item.CODART
    });
    const index = this.listadoArticulos.indexOf(item)
    if(index > -1){
      this.listadoArticulos[index].FAVORITO = !item.FAVORITO
    }
  }

  MostrarFavoritos() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta", query: {favoritos: "true"} });
  }

  imageError(item: ARTICULO){
    item.IMAGEN = this.imageUrl + "default.jpg";
  }

  //@ts-ignore
  changeItemsPage(event){

    this.itemsPerPage = event;
    this.currentPage = 1;

    this.paginar();
  }

   //@ts-ignore
   moreQuant(event, item: ARTICULO){
    
    if(Number(item.CANTIDAD) > item.STOCK){
      this.$toast.error("La cantidad introducida no es correcta, supera el stock disponible.");
      item.CANTIDAD = item.STOCK;
      this.AñadirACestav2(item)
    }
    else{
      if(item.CANTIDAD == 0)
        this.$root.$emit("RestCart", item);
      else
        this.AñadirACestav2(item)
    }
  }

  AñadirACestav2(item: ARTICULO) {
    this.$root.$emit("addToCartV2", item);
  }
}